import React from 'react';
import { sendClientLog } from 'services/logService';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true, errorInfo: { error, info }});
    // You can also log the error to an error reporting service
    console.log(error);
    console.log(info);
    sendClientLog('Error', `Error caught by ErrorBoundary. Error: ${error.toString()}. Component Stack: ${info.componentStack}`)
  }

  render() {
    if (this.state.hasError && this.props.fallbackRender) {
      // You can render any custom fallback UI
      return this.props.fallbackRender(this.state.errorInfo);
    }
    return this.props.children;
  }
}

export default ErrorBoundary